var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "20",
        "height": "20",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('path', {
      attrs: {
        "d": "M3.958 5h-.833a.625.625 0 110-1.25h13.75a.625.625 0 110 1.25H5.208v11.042a1.042 1.042 0 001.042 1.041h7.5a1.042 1.042 0 001.042-1.041V6.875a.625.625 0 111.25 0v9.167a2.292 2.292 0 01-2.292 2.291h-7.5a2.292 2.292 0 01-2.292-2.291V5zm4.375-2.083a.625.625 0 110-1.25h3.334a.625.625 0 010 1.25H8.333zm-.625 5.625a.625.625 0 111.25 0v5a.625.625 0 01-1.25 0v-5zm3.334 0a.625.625 0 111.25 0v5a.625.625 0 01-1.25 0v-5z",
        "fill": "var(--mainColor)",
        "fill-rule": "nonzero"
      }
    })]));
  }
};